import { Component, EventEmitter, Input, Output } from '@angular/core';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-form-action-button',
  templateUrl: './finx-form-action-button.component.html',
  styleUrls: ['./finx-form-action-button.component.scss'],
})
export class FinxFormActionButtonComponent {
  @Input() btnType = '';
  @Input() disabled = false;
  @Input() icon: string;
  @Input() contentStyle: baseCssConfigStyle;
  @Input() iconSize?: baseCssConfigStyle;
  @Input() text?: string;
  @Output() buttonEvent = new EventEmitter<Record<string, string>>();
  @Input() globalStylingClass = '';
  @Input() isAllowedGlobalStyling = false;

  actionTrigger(actionType: string) {
    this.buttonEvent.emit({
      action: actionType,
    });
  }
}
